import { useMemo, useCallback } from 'react';

import { NotificationSubscriptionSubject } from 'src/types/__generated__/graphql';
import useUser from './useUser';

export const useUserNotificationSubscriptions = () => {
    const user = useUser();

    const findSubscriptionStatusBySubject = useCallback(
        (subject: NotificationSubscriptionSubject) => {
            const subscription = user?.notificationSubscriptions.find((s) => s.subject === subject);
            return subscription?.status;
        },
        [user],
    );

    return useMemo(
        () =>
            !user
                ? null
                : {
                      savedSearch: {
                          emailNotificationsStatus: findSubscriptionStatusBySubject(
                              NotificationSubscriptionSubject.AdSearchResultsEmail,
                          ),
                      },
                  },
        [findSubscriptionStatusBySubject, user],
    );
};
